var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"echart-box-cla"},[_c('div',{staticClass:"chart_title_cla"},[_c('div',{staticClass:"title-bg-cla"}),_vm._v(" "),_c('div',{staticClass:"title-Text-cla"},[_vm._v(_vm._s(_vm.$t('dashboard.areaDeviceTop10')))])]),_vm._v(" "),_c('div',{staticClass:"echart-cla",attrs:{"id":"map_bar_chart"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-507c9643","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tenantManager/dashboard/mapBarChar/mapBarChar.vue
// module id = null
// module chunks = 